import React, { useRef } from 'react'



const Target = ({ size, shots, factor }) => {
    const draw = (context, size, factor) => {
        const size_canvas = size;
        const img_factor = factor || 2.5; //como ampliamos lo que se ve 
        const img_width = size_canvas * img_factor;
        const zoom = img_width / (size_canvas / 2);
        const centerImg_x = -(img_width - size_canvas) / 2

        const image = new Image();
        image.src = "/assets/images/pictos/arc/target.svg";


        image.onload = () => {
            context.drawImage(image, 0, 0, size_canvas, size_canvas, centerImg_x, centerImg_x, img_width, img_width);

            var img_mm = 1220;
            var centerShoots_x = img_width / zoom;
            var ratio = img_mm / img_width;
            //var factorCorrection = 1//factorCorrection || 10;  
            let cX, cY, caliber, valX, valY, coorX, coorY, _caliber
            Array.isArray(shots) && shots.forEach(shot => {
                cX = shot.codeX;
                cY = shot.codeY;
                caliber = shot.codeDIAM / 2
                //valX = (cX * factorCorrection);
                //valY = (cY * factorCorrection);
                //coorX = (centerShoots_x + (valX / ratio));
                //coorY = (centerShoots_x - (valY / ratio));

                coorX = (centerShoots_x + (cX / ratio));
                coorY = (centerShoots_x - (cY / ratio));


                context.beginPath();
                context.arc(coorX, coorY, caliber / ratio, 0, 2 * Math.PI);
                context.lineWidth = 10;
                // line color
                context.fillStyle = 'rgba(0, 0, 0, 0.5)';
                context.strokeStyle = 'rgba(255, 0, 0, 0.5)';
                context.fill();
                //context.stroke();
            })
        };
    };


    const canvas = useRef();
    React.useEffect(() => {
        const context = canvas.current.getContext('2d');
        draw(context, size, factor);
    });
    return (
        <canvas ref={canvas} height={size} width={size} />
    );
};


export default Target








